import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import { reactive, ref, toRefs, watch, onMounted } from 'vue';
import apis from '@/api';
import useFavorite from "./composables/useFavorite";
import TagModal from './components/TagModal.vue';
import AssetsBiz from './components/AssetsBiz.vue';
import AddAssetsProduct from './components/AddAssetsProduct.vue';
import download from "@/utils/download";
import SelectFavorite from "./components/SelectFavorite.vue";
import { srcType } from "@/utils/srcType";
import dayjs from "dayjs";
import common from "@/views/Home/MyNeeds/composables/common";
export default {
  components: {
    AssetsBiz,
    AddAssetsProduct,
    TagModal,
    SelectFavorite
  },
  props: {
    id: String
  },
  setup(props) {
    const detail = ref({});
    const tagModalShow = ref(false);
    const addAsProdc = ref({});
    const assetsBizRef = ref({});
    const selectFavoriteRef = ref({});
    const {
      unFavorite
    } = useFavorite();
    const {
      downloadAssetProductModel,
      singleDownload
    } = download();
    const {
      commonData
    } = common();
    const data = reactive({
      id: '',
      editShow: false,
      choseAsset: {},
      srcType: srcType,
      remark: '',
      status: '1',
      date: [],
      attachments: []
    });
    const getDetail = id => {
      apis.queryAssetById(id).then(res => {
        if (res.data.status == 1 && dayjs().isAfter(dayjs(res.data.endDate))) {
          res.data.status = 0;
        }
        detail.value = res.data;
      });
    };
    watch(() => props.id, id => {
      data.id = id;
      getDetail(id);
    }, {
      immediate: true
    });
    const favHandler = () => {
      if (detail.value.favorite) {
        // 取消收藏
        unFavorite(detail.value.id).then(() => {
          detail.value.favorite = false;
          ElMessage.success("已取消收藏");
        });
      } else {
        // 收藏
        data.choseAsset = detail.value;
        selectFavoriteRef.value.visible();
      }
    };
    const favorited = p => {
      data.choseAsset.favorite = true;
      ElMessage.success("收藏成功");
    };
    const addTagHandler = tag => {
      tagModalShow.value = false;
      apis.addAssetTag({
        assetsId: detail.value.id,
        tagNum: tag.tagNum,
        tagName: tag.tagName,
        tagParNum: tag.parNum
      }).then(res => {
        if (res.success && res.code === '200') {
          ElMessageBox({
            type: 'success',
            message: '添加成功'
          });
          getDetail(props.id);
        }
      });
    };
    const addAsProduct = () => {
      addAsProdc.value.visible();
    };
    const addAsProdcOk = () => {
      assetsBizRef.value.loadData();
    };
    const editHandler = () => {
      let info = JSON.parse(JSON.stringify(detail.value));
      data.date = [info.bgnDate, info.endDate];
      data.status = info.status;
      data.remark = info.remark;
      data.editShow = true;
    };
    const confirmEdit = () => {
      let json = {
        id: detail.value.id,
        bgnDate: data.date[0] || detail.value.bgnDate,
        endDate: data.date[1] || detail.value.endDate,
        status: data.status,
        remark: data.remark
      };
      apis.updateAsset(json).then(res => {
        if (res.success && res.code === '200') {
          ElMessage.success("保存成功");
          detail.value.remark = data.remark;
          detail.value.status = data.status;
          data.editShow = false;
        }
      });
    };
    const fileUpload = params => {
      const formData = new FormData();
      formData.append('fileList', params.file);
      formData.append("assetId", data.id);
      apis.impXlsassetProduct(formData).then(res => {
        console.log("res: ", res);
        if (res.success) {
          ElMessage.success("文件导入成功");
          assetsBizRef.value.loadData();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const loadDemandAttachs = () => {
      apis.getAttachments({
        assetsId: data.id
      }).then(res => {
        if (res.success) {
          data.attachments = res.data;
        }
      });
    };
    const getBelongDepart = code => {
      for (const bd of commonData.belongDeparts) {
        if (bd.code === code) {
          return bd.label;
        }
      }
    };
    onMounted(() => {
      loadDemandAttachs();
    });
    return {
      detail,
      commonData,
      tagModalShow,
      ...toRefs(data),
      selectFavoriteRef,
      addAsProduct,
      addAsProdcOk,
      addAsProdc,
      assetsBizRef,
      favorited,
      favHandler,
      addTagHandler,
      editHandler,
      confirmEdit,
      downloadAssetProductModel,
      fileUpload,
      singleDownload,
      getBelongDepart
    };
  }
};